import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X, User, GraduationCap, LogOut, Settings } from 'lucide-react';

const Navbar = () => {
}
export default Navbar;
